import sentryPlugin from '@bxs/vue-plugin-sentry'

export function initSentry (Vue) {
  Vue.use(sentryPlugin, {
    dsn: 'https://d77d93093ba24b85b5b4e43fdc0afb64@sentryv2.winbaoxian.cn/5',
    environment: process.env.NODE_ENV
  })
}
